import ApiService from "@/core/services/api.service";
//import i18nService from "@/core/services/i18n.service.js";
import SiteService from "@/core/services/site.service.js";

const state = {
    errors: null,
    collection: []
};

const getters = {
    bannerClientCollection(state) {
        return state.collection;
    },

    getBannerClientByID: (state) => (id) => {
        let item = state.collection.find((item) => item.id == id);
        if (!item) {
          item = null;
        }
        return item;
    }
};

const actions = {
    fetchBannerClient(context) {
        return new Promise((resolve) => {
            //let appLocale = i18nService.getActiveLanguage();
            ApiService.get(
                "pages/admin/" + SiteService.getActiveSiteId() + "/bannerClient"
            ).then(({ data }) => {
              context.commit("fetchBannerClient", data);
              resolve();
          });
        }).catch((error) => {
            console.log("Error!: ", error);
        });
    }
};

const mutations = {
    fetchBannerClient(state, data) {
      state.collection = data;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};